import { defineMessages } from "@formatjs/intl";

const PREFIX = "lms.case-example.artistic-pov-slide";
export const messages = defineMessages({
  title: {
    id: `${PREFIX}.title`,
  },
  accordionItem1Title: {
    id: `${PREFIX}.accordion-item1.title`,
  },
  accordionItem1Description: {
    id: `${PREFIX}.accordion-item1.description`,
  },
  accordionItem2Title: {
    id: `${PREFIX}.accordion-item2.title`,
  },
  accordionItem2Description: {
    id: `${PREFIX}.accordion-item2.description`,
  },
  accordionItem3Title: {
    id: `${PREFIX}.accordion-item3.title`,
  },
  accordionItem3Description: {
    id: `${PREFIX}.accordion-item3.description`,
  },
  bioNote: {
    id: `${PREFIX}.bio-note`,
  },
  collaboration: {
    id: `${PREFIX}.collaboration-info`,
  },
  bioMarloweTitle: {
    id: `${PREFIX}.bio.marlowe.title`,
  },
  bioMarloweDescription: {
    id: `${PREFIX}.bio.marlowe.description`,
  },
  bioMarloweLink: {
    id: `${PREFIX}.bio.marlowe.link`,
  },
  bioSkalTitle: {
    id: `${PREFIX}.bio.skal.title`,
  },
  bioSkalDescription: {
    id: `${PREFIX}.bio.skal.description`,
  },
  bioSkalLink: {
    id: `${PREFIX}.bio.skal.link`,
  },
  bioLauraTitle: {
    id: `${PREFIX}.bio.laura.title`,
  },
  bioLauraDescription: {
    id: `${PREFIX}.bio.laura.description`,
  },
  bioLauraLink: {
    id: `${PREFIX}.bio.laura.link`,
  },
  bioBuffTitle: {
    id: `${PREFIX}.bio.buff.title`,
  },
  bioBuffDescription: {
    id: `${PREFIX}.bio.buff.description`,
  },
  bioBuffLink: {
    id: `${PREFIX}.bio.buff.link`,
  },
});
